import { createRootRouteWithContext } from "@tanstack/react-router";

import { QueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Navbar } from "../components/layout";
import { PublicNavbarActions } from "../components/layout/PublicNavbar/PublicNavbarActions";
import { RootComponent } from "../components/routes/RootComponent";
import { Error } from "../pages/Error";
import { NotFound } from "../pages/NotFound";
import { tokenStorage } from "../utils/tokenStorage";

type TRouterContext = {
  queryClient: QueryClient;
};

const StatusLayout = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = Boolean(tokenStorage.getAccessToken());

  return (
    <>
      <Navbar
        brandTo={isAuthenticated ? "/app" : "/"}
        rightContent={<PublicNavbarActions isAuthenticated={isAuthenticated} variant="desktop" />}
        mobileNavContent={<PublicNavbarActions isAuthenticated={isAuthenticated} variant="mobile" />}
      />
      {children}
    </>
  );
};

export const Route = createRootRouteWithContext<TRouterContext>()({
  component: RootComponent,
  notFoundComponent: () => (
    <StatusLayout>
      <NotFound />
    </StatusLayout>
  ),
  errorComponent: ({ error, reset }) =>
    error instanceof TypeError ? (
      <Error error={error} reset={reset} />
    ) : (
      <StatusLayout>
        <Error error={error} reset={reset} />
      </StatusLayout>
    ),
});
